import React, { useState } from "react";
import { IoFilterOutline, IoCloseOutline } from "react-icons/io5";
import SidebarItemNew from "../../components/Sidebar/SidebarItemNew";
import {
  Card,
  SideBarActiveDiv,
  SideBarActiveDivNew,
  SideBarNormalDiv,
  SideBarNormalDivNew,
} from "../Theme";
// ...existing code...

function SidebarJournal({
  data,
  selectedOption,
  setSelectedOption,
  isJournal,
  isShared,
  valueId,
  groupedValues,
}) {
  const [show, setShow] = useState(false);

  const [sidebar, setSidebar] = useState(data.open);

  return (
    <div className="lg:w-64 md:top-32 flex flex-row lg:flex-col-reverse">
      <div className="lg:hidden border-bottom-f1 flex items-center">
        <div className="bg-white flex items-center h-12 pl-10 pr-4 mr-4 ">
          <IoFilterOutline
            className="w-6 h-6 cursor-pointer"
            onClick={() => setShow(true)}
          />
        </div>
      </div>
      <Card
        className={
          show
            ? `inline-block lg:bg-white lg:bg-opacity-100 
                                 lg:mt-0 bg-black bg-opacity-60 w-full h-[calc(100vh-88px)]  
                                overflow-auto lg:pr-20 fixed topbar-offset lg:relative z-10 pr-16`
            : `hidden lg:inline-block lg:bg-white lg:bg-opacity-100 
                                mt-20 lg:mt-0 
                                overflow-hidden fixed top-0 lg:relative z-10 border20px pb-4`
        }
      >
        <>
          <div
            className="flex pt-5 pb-3 pl-2 lg:pt-0 lg:mt-2 lg:mb-1 pr-2 items-center cursor-pointer border-bottom-f1"
            onClick={() => {
              setSelectedOption(-1, "");
              setSidebar(true);
            }}
          >
            {selectedOption?.type === -1 ? (
              <SideBarActiveDivNew className="font-14px font-bold cursor-pointer w-full py-1.5 pl-2 ">
                All posts
              </SideBarActiveDivNew>
            ) : (
              <SideBarNormalDivNew className="font-14px font-bold cursor-pointer w-full pl-2 py-1.5">
                All posts
              </SideBarNormalDivNew>
            )}
          </div>
          <div className="border-bottom-f1">
            <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-1 lg:mb-0 items-center">
              <div className="font-14px font-bold cursor-default pl-1 w-full py-1 lightColor">
                Shared Post
              </div>
            </div>
            <div className="w-full px-4">
              {data.slice(0, 2).map((items, index) => {
                return (
                  <SidebarItemNew
                    key={index}
                    isLast={index === data.slice(0, 2).length - 1}
                    items={items}
                    isJournal={isJournal}
                    isShared={isShared}
                    selectedOption={selectedOption}
                    setSelectedOption={(selectedValue) =>
                      setSelectedOption(index, selectedValue)
                    }
                    valueId={valueId}
                  />
                );
              })}
              <div
                className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                onClick={() => setShow(false)}
              >
                <IoCloseOutline className="w-8 h-8" />
              </div>
            </div>
          </div>
          <div className="border-bottom-f1">
            <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-2  cursor-default lg:mb-0 items-center ">
              <div className="font-14px font-bold cursor pl-1 w-full py-1 lightColor">
                Tags
              </div>
            </div>
            <div className="w-full px-4">
              {data.slice(2).map((items, index) => {
                return (
                  <SidebarItemNew
                    key={index}
                    isLast={index === data.slice(2).length - 1}
                    items={items}
                    isJournal={isJournal}
                    isShared={isShared}
                    selectedOption={selectedOption}
                    setSelectedOption={(selectedValue) =>
                      setSelectedOption(index + 2, selectedValue)
                    }
                    valueId={valueId}
                  />
                );
              })}
              <div
                className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                onClick={() => setShow(false)}
              >
                <IoCloseOutline className="w-8 h-8" />
              </div>
            </div>
          </div>
          <div className="border-bottom-f1">
            <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-2  cursor-default lg:mb-0 items-center ">
              <div className="font-14px font-bold cursor pl-1 w-full py-1 lightColor">
                Values/Competencies
              </div>
            </div>
            <div className="w-full px-4">
              {groupedValues.map((items, index) => {
                return (
                  <SidebarItemNew
                    key={index}
                    isLast={index === groupedValues.length - 1}
                    items={items}
                    isJournal={isJournal}
                    isShared={isShared}
                    selectedOption={selectedOption}
                    setSelectedOption={(selectedValue) =>
                      setSelectedOption(5, selectedValue)
                    }
                    valueId={valueId}
                  />
                );
              })}
              <div
                className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                onClick={() => setShow(false)}
              >
                <IoCloseOutline className="w-8 h-8" />
              </div>
            </div>
          </div>
        </>
      </Card>
    </div>
  );
}

export default SidebarJournal;
